import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Tooltip } from '../../../common/tooltip'
import { EMPTY_VALUE } from '../../../utils/common'
import { selectScoreRanges } from '../store/slice'

import classes from './index.module.scss'
import { ScoreRangeTooltip } from './ScoreRangeTooltip'

export const ScoreItem = ({ scoreType, score }) => {
  const scoreRanges = useSelector(selectScoreRanges(scoreType))

  const scoreRangeIndex = scoreRanges.findIndex(
    (range) => score >= range.scoreRange_Min && score <= range.scoreRange_Max,
  )

  return (
    <Element className={classes.scoreItem}>
      <Element className={classes.scoreRange}>
        {scoreRangeIndex === -1 ? (
          <Element
            className="flex1 minW0 textCenter"
            style={{
              padding: '3px 0',
              backgroundColor: '#BCBCBC',
              color: '#FFFFFF',
              fontSize: 24,
            }}
          >
            {EMPTY_VALUE}
          </Element>
        ) : (
          scoreRanges.map((item, index) => (
            <Element
              key={item.color}
              className="flex1 minW0 "
              style={{
                backgroundColor: item.color,
                opacity: index === scoreRangeIndex ? 1 : 0.4,
              }}
            >
              <Tooltip
                tooltipContent={<ScoreRangeTooltip item={item} />}
                tooltipSpace={-5}
                contentStyle={{ width: '100%' }}
                contentClass="h100"
              >
                <Element
                  className="wh100 textCenter fw600"
                  style={{
                    padding: '3px 0',
                    color: '#FFFFFF',
                    fontSize: 20,
                  }}
                >
                  {index === scoreRangeIndex ? score : ''}
                </Element>
              </Tooltip>
            </Element>
          ))
        )}
      </Element>

      {scoreRangeIndex !== -1 && (
        <Element className={classes.scoreName} style={{ color: '#3A414B' }}>
          {scoreRanges[scoreRangeIndex]?.scoreRangeName}
        </Element>
      )}
    </Element>
  )
}
